/**
 * FaqPage - Frequently asked questions for judges.
 *
 * Common tricky situations and how to handle them.
 * Fetches FAQ items from the API.
 */

import { Link as RouterLink } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import {
  Box,
  Button,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  CircularProgress,
  Alert,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import BackIcon from '@mui/icons-material/ArrowBack';

import { faqApi } from '@/api/client';

export function FaqPage() {
  const { data: faqItems, isLoading, error } = useQuery({
    queryKey: ['faq'],
    queryFn: faqApi.list,
  });

  return (
    <Box sx={{ maxWidth: 600, mx: 'auto' }}>
      <Button
        startIcon={<BackIcon />}
        component={RouterLink}
        to="/judge"
        sx={{ mb: 2 }}
      >
        Takaisin
      </Button>

      <Typography variant="h5" fontWeight={700} gutterBottom>
        Kinkkiset tilanteet (FAQ)
      </Typography>

      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Vastauksia yleisimpiin kysymyksiin tuomarin työssä.
      </Typography>

      {isLoading && (
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
          <CircularProgress />
        </Box>
      )}

      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          Virhe ladattaessa FAQ-tietoja. Yritä myöhemmin uudelleen.
        </Alert>
      )}

      {faqItems?.map((item) => (
        <Accordion key={item.id} disableGutters>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography fontWeight={500}>{item.question}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography
              variant="body2"
              sx={{ whiteSpace: 'pre-line' }}
            >
              {item.answer}
            </Typography>
          </AccordionDetails>
        </Accordion>
      ))}
    </Box>
  );
}

